module.exports = __webpack_public_path__ + "img/Certificate.c10bb5a8.png";